const operation = {
  // pc端订单列表信息
  trainingOrderList: `/authApi/training/studio/order/list`,
  // 获取工作室代练人员信息
  trainingPerformance: `/authApi/training/studio/person/list`,
  // 获取工作室代练人员绩效信息
  trainingPersonPerformance: `/authApi/training/studio/person/performance/list`,
  // 获取代练账单信息 -- 账单查询列表
  trainingBill: `/authApi/training/bill`,

  // 用户退款列表
  userRefundList: `/authApi/training/user/refund/list`,
  // 用户是否是工作室人员
  trainingIdentity: `/authApi/training/user/identity`,
  // 添加工作室人员信息
  trainingPersonAdd: `/authApi/training/studio/person/add`,
  // 工作室人员权限管理
  trainingPermissions: `/authApi/training/studio/person/permissions`,
  // 设置工作室人员状态
  trainingStatus: `/authApi/training/studio/person/status/change`,
  // 工作室人员解绑
  trainingUnbind: `/authApi/training/studio/person/unbind`,

  // 代练玩家上传截图
  trainingScreenshot: `/authApi/training/game/screenshot`,
  // 设置工作室分成比例
  trainingAatio: `/authApi/training/setting/share/ratio`,
  // 变更工作室基础信息
  studioChange: `/authApi/training/studio/change`,
  // 添加代练人员时，获取代练人员昵称等数据
  trainingUserInfo: `/authApi/training/user/info`,
  // 代练玩家上传游戏截图
  screenshot: `/authApi/training/game/screenshot`,
  // 更新代练玩家上传游戏截图
  gameScreenshotChange: `/authApi/training/gameScreenshotChange`,
  // 获取代练人员已经上传的游戏截图信息
  screenshotList: `/authApi/training/game/screenshot/list`,
  // 获取代练玩家上传的游戏截图
  screenshotListV1: `/authApi/training/v1/game/screenshot/list`,
  // 获取工作室详情
  studioDetail: `/authApi/training/studio/detail`,
  // 根据订单ID获取订单详情
  orderDetail: `/authApi/training/order/detail`,
  // 指定代练 -- 订单管理
  assign: `/authApi/training/assign`,
  // pc端取消订单 -- 订单管理
  orderCancel: `/authApi/training/studio/order/cancel`,
  // 获取当前用户下工作室可以接单的代练人员 -- 订单管理
  orderPersonList: `/authApi/training/acceptable/order/person/list`,
  // 获取私聊和群聊参数 -- 订单管理
  imInfo: `/authApi/training/im/info`,
  // 代练人员点击订单结单 -- 订单管理
  finishOrder: `/authApi/training/user/finish/order`,
  // pc端 获取工作室具体人员订单列表信息 -- 人员绩效
  userOrder: `/authApi/training/user/order/list`,
  // 保证金充值 -- 投诉处理
  bondPay: `/authApi/training/create/bond/pay`,
  // 获取保证金充值是否成功 -- 投诉处理
  payStatus: `/authApi/training/bond/pay/status`,
  // 保证金账单(保证金明细) -- 投诉处理
  bondBill: `/authApi/training/bond/bill`,
  // 保证金信息接口 -- 投诉处理
  bondFund: `/authApi/training/bond/fund`,
  // 工作室同意退款 -- 投诉处理
  agreeFund: `/authApi/training/studio/agree/refund`,
  // 协商退款 -- 投诉处理
  consultFund: `/authApi/training/consult/refund`,
  // 工作室拒绝退款 -- 投诉处理
  refuseFund: `/authApi/training/studio/refuse/refund`,
  // 获取退款投诉处理详情信息 -- 投诉处理
  negotiationList: `/authApi/training/negotiation/list`,
  // 客服仲裁补充信息 -- 投诉处理
  negotiationInfoFill: `/authApi/training/negotiation/info/fill`,
  // 工作室人员权限管理 授权后可在订单界面自主接单
  permissions: `/authApi/training/studio/person/permissions`,
  // 代练试玩游戏
  demoStartGame: `/authApi/training/studio/demo/game`,
  // 代练启动游戏
  startGame: `/authApi/training/studio/start/game`,
  // 微信下单时 获取工作室信息
  studioInfo: `/authApi/training/v1/studio/info`,
  // 微信下单
  createOrder: `/authApi/training/pre/create/order`,
  // 订单直播间绑定和解除
  bindStudioLive: `/authApi/training/bindStudioLive`,
  // 获取工作室功能开关
  studioSwitch: `/authApi/training/studio/functionSwitch`
};

export default operation;
